import React, { useEffect, useState } from "react";
import { Tabs, Form, Row, Col, Checkbox, Collapse } from "antd";
import NavBar from "../../communs/NavBar";
import SecondaryButton from "../../../biblio/Buttons/SecondaryButton";
import PrimaryButton from "../../../biblio/Buttons/PrimaryButton";
import ApplicantData from "./Applicant-Content/index";
import folder from "../../../assets/icons/folder-icon.svg";
import tab from "../../../assets/icons/tab-click-icon.svg";

import dollar from "../../../assets/icons/money-icon.svg";
import dollarWhite from "../../../assets/icons/tabs-icons/money-icon-w.svg";
import location from "../../../assets/icons/location-icon.svg";
import locationWhite from "../../../assets/icons/tabs-icons/location-icon-w.svg";
import users from "../../../assets/icons/users-icon.svg";
import usersWhite from "../../../assets/icons/tabs-icons/users-icon-w.svg";
import user from "../../../assets/icons/tabs-icons/user-icon-df.svg";
import userWhite from "../../../assets/icons/tabs-icons/user-icon-w.svg";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../apis/store";
import {
  getAllAcademicLevels,
  getAllDeathReasons,
  getAllGovernorates,
  getAllHealthStates,
  getAllHousingOwnerships,
  getAllHousingStates,
  getAllHousingTypes,
  getAllIdentificationTypes,
  getAllIncomeSources,
  getAllMaritalStatus,
  getAllNationality,
  toAddBeneficiary,
  toUpdateBeneficiary,
  toAddFamilyMembers,
  toAddHousingInformations,
  toAddSourceIncomes,
  toAddProofDocuments,
  toAddLiabitities,
} from "../../../apis/actions/recipient.actions";
import AddressData from "./family-form-address";
import HousingData from "./family-form-housing";
import IncomeSourceData from "./family-income-sources";
import IdentityPapersData from "./family-identity-papers";
import FamilyData from "./family-form-info";
import OtpModal from "../../../components/otpModal/OtpModal";
import {
  showNotitfication,
  toFormatDate,
} from "../../../components/utils/utils";
import LiabilityData from "./family-liability-form";
const { TabPane } = Tabs;

const AddRecipient = () => {
  const [formBeneficiary] = Form.useForm();
  const [formOrphans] = Form.useForm();
  const [formIncomes] = Form.useForm();
  const [formHousing] = Form.useForm();
  const [formDocs] = Form.useForm();
  const [formLiability] = Form.useForm();
  const dispatch = useDispatch<AppDispatch>();
  const [activeTab, setActiveTab] = useState<string>("1");
  const [completedTabs, setCompletedTabs] = useState<string[]>([]);
  const [isChecked, setIsChecked] = useState<boolean>(false);
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const [beneficiryId, setBeneficiryId] = useState<number>(-1);
  const [width, setWidth] = useState<number>(window.innerWidth);
  const [openedPanels, setOpenedPanels] = useState<boolean[]>([]);
  const [nbOrphan, setNbOrphan] = useState<number>(1);

  /** Mobile */
  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }
  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  const isMobile = width <= 768;

  const handleCollapseChange = (key: string | string[]) => {
    const newOpenedPanels = [...openedPanels]; // Copy the current state
    if (Array.isArray(key)) {
      key.forEach((k) => {
        newOpenedPanels[parseInt(k)] = true; // Mark this panel as opened
      });
    } else {
      newOpenedPanels[parseInt(key)] = true; // Mark this single panel as opened
    }
    setOpenedPanels(newOpenedPanels); // Update state
    handleNextTab();
  };

  /** mobile end */
  const handleCheckboxChange = (e: any) => {
    setIsChecked(e.target.checked);
    formDocs.setFieldValue("declaration_accuracy", e.target.checked);
  };

  const handleCloseOtpModal = () => {
    setIsModalVisible(false);
  };

  /** Use Selector part  */
  const {
    nationality,
    governorates,
    academicLevels,
    deathReasons,
    maritalStatus,
    healthStates,
    identificationTypes,
    housingTypes,
    housingStates,
    housingOwnerships,
    incomeSources,
    loading,
  } = useSelector((state: RootState) => state.recipient);

  /** navigate to next tab */
  const handleNextTab = async () => {
    try {
      const json = toFormatDataForApi();
      var data: any;
      switch (activeTab) {
        case "1":
          await formBeneficiary.validateFields();
          if (beneficiryId === -1) {
            data = (await dispatch(toAddBeneficiary(json))) as any;
          } else {
            data = (await dispatch(toUpdateBeneficiary(json))) as any;
          }
          break;
        case "2":
          await formOrphans.validateFields();
          data = (await dispatch(toAddFamilyMembers(json))) as any;

          break;
        case "3":
          await formHousing.validateFields();
          data = (await dispatch(toAddHousingInformations(json))) as any;
          break;
        case "4":
          await formIncomes.validateFields();
          data = (await dispatch(toAddSourceIncomes(json))) as any;
          break;
        case "5":
          await formLiability.validateFields();
          data = (await dispatch(toAddLiabitities(json))) as any;
          break;
        case "6":
          await formDocs.validateFields();
          data = (await dispatch(toAddProofDocuments(json))) as any;
          break;
        default:
          break;
      }

      goNext(data);
    } catch (error) {
      console.error(error);
    }
  };

  /** navigate to prev tab */
  const handlePrevTab = () => {
    const prevTab = (parseInt(activeTab) - 1).toString();
    setActiveTab(prevTab);
  };

  /** check if tab is disabled */
  const isTabDisabled = (key: string): boolean => {
    return (
      key !== "1" && !completedTabs.includes((parseInt(key) - 1).toString())
    );
  };

  /** get all select values */

  useEffect(() => {
    dispatch(getAllNationality());
    dispatch(getAllGovernorates());
    dispatch(getAllDeathReasons());
    dispatch(getAllMaritalStatus());
    dispatch(getAllHealthStates());
    dispatch(getAllAcademicLevels());
    dispatch(getAllIdentificationTypes());
    dispatch(getAllHousingTypes());
    dispatch(getAllHousingStates());
    dispatch(getAllHousingOwnerships());
    dispatch(getAllIncomeSources());
    formIncomes.setFieldValue("material_state_ids", []);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderTabTitle = (
    key: string,
    activeIcon: React.ReactNode,
    inactiveIcon: React.ReactNode,
    title: string
  ) => {
    return (
      <span
        style={{ display: "flex", alignItems: "center", gap: "1vh" }}
        className={`${
          activeTab === key
            ? "takaful--recipient-tab-progress"
            : completedTabs.includes(key)
            ? "takaful--recipient-tab-completed"
            : ""
        }`}
      >
        {activeTab === key
          ? activeIcon
          : completedTabs.includes(key)
          ? inactiveIcon
          : activeIcon}
        {title}
      </span>
    );
  };

  const toFormatDataForApi = () => {
    switch (activeTab) {
      case "1":
        if (beneficiryId !== -1) {
          return {
            beneficiary_request_id: beneficiryId,
            /*Applicant Data */
            applicant_first_name: formBeneficiary.getFieldValue(
              "applicant_first_name"
            ),
            applicant_father_name: formBeneficiary.getFieldValue(
              "applicant_father_name"
            ),
            applicant_grandfather_name: formBeneficiary.getFieldValue(
              "applicant_grandfather_name"
            ),
            applicant_family_name: formBeneficiary.getFieldValue(
              "applicant_family_name"
            ),
            applicant_identification_type_id: formBeneficiary.getFieldValue(
              "applicant_identification_type_id"
            )?.value,
            applicant_identification_number: formBeneficiary.getFieldValue(
              "applicant_identification_number"
            ),
            applicant_phone: formBeneficiary.getFieldValue("applicant_phone"),
            /* Father Data */
            father_firstname: formBeneficiary.getFieldValue("father_firstname"),
            father_father_name:
              formBeneficiary.getFieldValue("father_father_name"),
            father_grandfather_name: formBeneficiary.getFieldValue(
              "father_grandfather_name"
            ),
            father_family_name:
              formBeneficiary.getFieldValue("father_family_name"),
            father_eng_name: formBeneficiary.getFieldValue("father_eng_name"),
            father_birthday: toFormatDate(
              formBeneficiary.getFieldValue("father_birthday")
            ),
            father_country_id:
              formBeneficiary.getFieldValue("father_country_id")?.value,
            father_identification_type_id: formBeneficiary.getFieldValue(
              "father_identification_type_id"
            )?.value,
            father_identification_number: formBeneficiary.getFieldValue(
              "father_identification_number"
            ),
            father_identification_deadline: formBeneficiary.getFieldValue(
              "father_identification_deadline"
            )
              ? toFormatDate(
                  formBeneficiary.getFieldValue(
                    "father_identification_deadline"
                  )
                )
              : "",
            father_identification_source: formBeneficiary.getFieldValue(
              "father_identification_source"
            ),
            father_identification_date: toFormatDate(
              formBeneficiary.getFieldValue("father_identification_date")
            ),
            death_date: toFormatDate(
              formBeneficiary.getFieldValue("death_date")
            ),
            death_reason_id:
              formBeneficiary.getFieldValue("death_reason_id")?.value,
            ex_profession: formBeneficiary.getFieldValue("ex_profession"),
            father_death_certificate_image_ids: formBeneficiary.getFieldValue(
              "father_death_certificate_image_ids"
            ),
            /* Mother Data */
            mother_firstname: formBeneficiary.getFieldValue("mother_firstname"),
            mother_father_name:
              formBeneficiary.getFieldValue("mother_father_name"),
            mother_grandfather_name: formBeneficiary.getFieldValue(
              "mother_grandfather_name"
            ),
            mother_family_name:
              formBeneficiary.getFieldValue("mother_family_name"),
            mother_eng_name: formBeneficiary.getFieldValue("mother_eng_name"),
            mother_identification_type_id: formBeneficiary.getFieldValue(
              "mother_identification_type_id"
            )?.value,
            mother_identification_number: formBeneficiary.getFieldValue(
              "mother_identification_number"
            ),
            mother_identification_deadline:
              toFormatDate(
                formBeneficiary.getFieldValue("mother_identification_deadline")
              ) ?? "",
            mother_identification_source: formBeneficiary.getFieldValue(
              "mother_identification_source"
            ),
            mother_identification_date: toFormatDate(
              formBeneficiary.getFieldValue("mother_identification_date")
            ),
            mother_phone: formBeneficiary.getFieldValue("mother_phone") ?? "",
            mother_country_id:
              formBeneficiary.getFieldValue("mother_country_id")?.value,
            mother_birthday: toFormatDate(
              formBeneficiary.getFieldValue("mother_birthday")
            ),
            marital_status_id:
              formBeneficiary.getFieldValue("marital_status_id")?.value,
            academic_level_id:
              formBeneficiary.getFieldValue("academic_level_id")?.value,
            health_state_id:
              formBeneficiary.getFieldValue("health_state_id")?.value,
            mother_identify_image_ids: formBeneficiary.getFieldValue(
              "mother_identify_image_ids"
            ),
          };
        } else {
          return {
            /*Applicant Data */
            applicant_first_name: formBeneficiary.getFieldValue(
              "applicant_first_name"
            ),
            applicant_father_name: formBeneficiary.getFieldValue(
              "applicant_father_name"
            ),
            applicant_grandfather_name: formBeneficiary.getFieldValue(
              "applicant_grandfather_name"
            ),
            applicant_family_name: formBeneficiary.getFieldValue(
              "applicant_family_name"
            ),
            applicant_identification_type_id: formBeneficiary.getFieldValue(
              "applicant_identification_type_id"
            )?.value,
            applicant_identification_number: formBeneficiary.getFieldValue(
              "applicant_identification_number"
            ),
            applicant_phone: formBeneficiary.getFieldValue("applicant_phone"),
            /* Father Data */
            father_firstname: formBeneficiary.getFieldValue("father_firstname"),
            father_father_name:
              formBeneficiary.getFieldValue("father_father_name"),
            father_grandfather_name: formBeneficiary.getFieldValue(
              "father_grandfather_name"
            ),
            father_family_name:
              formBeneficiary.getFieldValue("father_family_name"),
            father_eng_name: formBeneficiary.getFieldValue("father_eng_name"),
            father_birthday: toFormatDate(
              formBeneficiary.getFieldValue("father_birthday")
            ),
            father_country_id:
              formBeneficiary.getFieldValue("father_country_id")?.value,
            father_identification_type_id: formBeneficiary.getFieldValue(
              "father_identification_type_id"
            )?.value,
            father_identification_number: formBeneficiary.getFieldValue(
              "father_identification_number"
            ),
            father_identification_deadline: formBeneficiary.getFieldValue(
              "father_identification_deadline"
            )
              ? toFormatDate(
                  formBeneficiary.getFieldValue(
                    "father_identification_deadline"
                  )
                )
              : "",
            father_identification_source: formBeneficiary.getFieldValue(
              "father_identification_source"
            ),
            father_identification_date: toFormatDate(
              formBeneficiary.getFieldValue("father_identification_date")
            ),
            death_date: toFormatDate(
              formBeneficiary.getFieldValue("death_date")
            ),
            death_reason_id:
              formBeneficiary.getFieldValue("death_reason_id")?.value,
            ex_profession: formBeneficiary.getFieldValue("ex_profession"),
            father_death_certificate_image_ids: formBeneficiary.getFieldValue(
              "father_death_certificate_image_ids"
            ),
            /* Mother Data */
            mother_firstname: formBeneficiary.getFieldValue("mother_firstname"),
            mother_father_name:
              formBeneficiary.getFieldValue("mother_father_name"),
            mother_grandfather_name: formBeneficiary.getFieldValue(
              "mother_grandfather_name"
            ),
            mother_family_name:
              formBeneficiary.getFieldValue("mother_family_name"),
            mother_eng_name: formBeneficiary.getFieldValue("mother_eng_name"),
            mother_identification_type_id: formBeneficiary.getFieldValue(
              "mother_identification_type_id"
            )?.value,
            mother_identification_number: formBeneficiary.getFieldValue(
              "mother_identification_number"
            ),
            mother_identification_deadline:
              toFormatDate(
                formBeneficiary.getFieldValue("mother_identification_deadline")
              ) ?? "",
            mother_identification_source: formBeneficiary.getFieldValue(
              "mother_identification_source"
            ),
            mother_identification_date: toFormatDate(
              formBeneficiary.getFieldValue("mother_identification_date")
            ),
            mother_phone: formBeneficiary.getFieldValue("mother_phone") ?? "",
            mother_country_id:
              formBeneficiary.getFieldValue("mother_country_id")?.value,
            mother_birthday: toFormatDate(
              formBeneficiary.getFieldValue("mother_birthday")
            ),
            marital_status_id:
              formBeneficiary.getFieldValue("marital_status_id")?.value,
            academic_level_id:
              formBeneficiary.getFieldValue("academic_level_id")?.value,
            health_state_id:
              formBeneficiary.getFieldValue("health_state_id")?.value,
            mother_identify_image_ids: formBeneficiary.getFieldValue(
              "mother_identify_image_ids"
            ),
          };
        }
      case "2":
        return {
          beneficiary_request_id: beneficiryId,
          beneficiary_orphan_ids: formOrphans.getFieldValue(
            "beneficiary_orphan_ids"
          ),
        };

      case "3":
        return {
          beneficiary_request_id: beneficiryId,

          governorate_id: formHousing.getFieldValue("governorate_id")?.value,
          neighborhood_id: formHousing.getFieldValue("neighborhood_id")?.value,
          national_address: formHousing.getFieldValue("national_address"),
          national_address_attachment_ids: formHousing.getFieldValue(
            "national_address_attachment_ids"
          ),
          housing_state_id:
            formHousing.getFieldValue("housing_state_id")?.value,
          housing_type_id: formHousing.getFieldValue("housing_type_id")?.value,
          housing_ownership_id: formHousing.getFieldValue(
            "housing_ownership_id"
          )?.value,
          rooms_number: formHousing.getFieldValue("rooms_number"),
          rent_amount: formHousing.getFieldValue("rent_amount"),
          electronic_contract_attachment_ids: formHousing.getFieldValue(
            "electronic_contract_attachment_ids"
          ),
        };

      case "4":
        return {
          beneficiary_request_id: beneficiryId,

          has_debt: formIncomes.getFieldValue("has_debt"),
          debt_amount: formIncomes.getFieldValue("debt_amount"),
          debt_reason: formIncomes.getFieldValue("debt_reason"),
          material_state_ids: formIncomes.getFieldValue("material_state_ids"),
        };

      case "5":
        return {
          beneficiary_request_id: beneficiryId,

          liability_ids: formLiability.getFieldValue("liability_ids"),
        };
      case "6":
        return {
          beneficiary_request_id: beneficiryId,
          family_record_image_1_ids: formDocs.getFieldValue(
            "family_record_image_1_ids"
          ),
          declaration_accuracy: formDocs.getFieldValue("declaration_accuracy"),
          father_death_certificate_image_ids: formDocs.getFieldValue(
            "father_death_certificate_image_ids"
          ),
        };

      default:
        break;
    }
  };

  const goNext = async (data: any) => {
    const beneficiary = data?.payload?.data?.result;
    if (beneficiary?.code === 200) {
      showNotitfication(beneficiary?.message, "success");
      // eslint-disable-next-line eqeqeq
      if (activeTab == "1" && beneficiryId === -1) {
        setBeneficiryId(beneficiary.beneficiary_request_id);
      }
      if (parseInt(activeTab) + 1 === 4) {
        const selectedMaterialStatus = maritalStatus?.data.filter(
          (el: any) =>
            el.id === formBeneficiary.getFieldValue("marital_status_id")?.key
        );

        const nb =
          selectedMaterialStatus.length > 0 &&
          !selectedMaterialStatus[0].deceased
            ? 1
            : 0;

        const orphanCount =
          formOrphans.getFieldValue("beneficiary_orphan_ids")?.length + nb;
        formIncomes.setFieldValue("beneficiaries_number0", orphanCount);
        setNbOrphan(orphanCount);
      }
      if (activeTab === "6") {
        setTimeout(() => {
          setIsModalVisible(true);
        }, 3000);
      } else {
        const nextTab = (parseInt(activeTab) + 1).toString();
        setActiveTab(nextTab);
        if (!completedTabs.includes(activeTab)) {
          setCompletedTabs([...completedTabs, activeTab]);
        }
      }
    } else {
      showNotitfication(beneficiary?.message, "error");
    }
  };

  /** To get form values on change */
  const [, setFormValues] = useState({});
  const onValuesChange = (changedValues: any) => {
    setFormValues(changedValues);
  };

  return (
    <>
      <NavBar variant="homePage" />
      <div className="takaful--add-recipient">
        <div className="takaful--add-recipient-title-image">
          <div className="takaful--title-tabs">
            <span>تسجيل مستفيد جديد</span>
          </div>
        </div>
        {isMobile ? (
          <div style={{ direction: "rtl" }}>
            <Collapse
              className="takaful--collapse-recipient"
              accordion
              defaultActiveKey="1"
              activeKey={activeTab}
              onChange={handleCollapseChange}
            >
              <Collapse.Panel
                disabled={isTabDisabled("1")}
                className="takaful--header-recipient-Panel takaful--header-radius"
                key="1"
                header={
                  <div className="takaful--header-recipient-container">
                    <div className="takaful--header-recipient-collapse">
                      <img width={15} src={user} alt="users" />
                      <span className="takaful--add-recipient-title">
                        بيانات الأب و الأم
                      </span>
                    </div>
                  </div>
                }
              >
                <Form
                  form={formBeneficiary}
                  layout="vertical"
                  onValuesChange={onValuesChange}
                >
                  <ApplicantData
                    nationality={nationality}
                    academicLevels={academicLevels}
                    deathReasons={deathReasons}
                    maritalStatus={maritalStatus}
                    healthStates={healthStates}
                    identificationTypes={identificationTypes}
                    form={formBeneficiary}
                  />
                </Form>
                <div className="takaful--add-recipient-btn-container">
                  <SecondaryButton
                    title={activeTab === "6" ? "تسجيل" : "التالي"}
                    onClick={handleNextTab}
                    disabled={loading || (activeTab === "6" && !isChecked)}
                    loading={loading}
                  />
                  {activeTab !== "1" && (
                    <PrimaryButton
                      title="السابق"
                      className="takaful--primary-button-prev"
                      onClick={handlePrevTab}
                      disabled={loading}
                    />
                  )}
                </div>
              </Collapse.Panel>

              <Collapse.Panel
                className="takaful--header-recipient-Panel takaful--header-radius"
                key="2"
                disabled={isTabDisabled("2")}
                header={
                  <div className="takaful--header-recipient-container">
                    <div className="takaful--header-recipient-collapse">
                      <img width={20} src={users} alt="users" />
                      <span className="takaful--add-recipient-title">
                        بيانات أفراد الأسرة
                      </span>
                    </div>
                  </div>
                }
              >
                <Form form={formOrphans} layout="vertical">
                  <FamilyData
                    parentForm={formBeneficiary}
                    form={formOrphans}
                    nationality={nationality}
                    identificationTypes={identificationTypes}
                    maritalStatus={maritalStatus}
                  />
                </Form>
                <div className="takaful--add-recipient-btn-container">
                  <SecondaryButton
                    title={activeTab === "6" ? "تسجيل" : "التالي"}
                    onClick={handleNextTab}
                    disabled={loading || (activeTab === "6" && !isChecked)}
                    loading={loading}
                  />
                  {activeTab !== "1" && (
                    <PrimaryButton
                      title="السابق"
                      className="takaful--primary-button-prev"
                      onClick={handlePrevTab}
                      disabled={loading}
                    />
                  )}
                </div>
              </Collapse.Panel>
              <Collapse.Panel
                disabled={isTabDisabled("3")}
                className="takaful--header-recipient-Panel takaful--header-radius"
                key="3"
                header={
                  <div className="takaful--header-recipient-container">
                    <div className="takaful--header-recipient-collapse">
                      <img width={15} src={location} alt="localtion" />
                      <span className="takaful--add-recipient-title">
                        بيانات السكن
                      </span>
                    </div>
                  </div>
                }
              >
                <Form form={formHousing} layout="vertical">
                  <HousingData
                    form={formHousing}
                    housingTypes={housingTypes}
                    housingStates={housingStates}
                    housingOwnerships={housingOwnerships}
                  />
                  <AddressData governorates={governorates} form={formHousing} />
                </Form>
                <div className="takaful--add-recipient-btn-container">
                  <SecondaryButton
                    title={activeTab === "6" ? "تسجيل" : "التالي"}
                    onClick={handleNextTab}
                    disabled={loading || (activeTab === "6" && !isChecked)}
                    loading={loading}
                  />
                  {activeTab !== "1" && (
                    <PrimaryButton
                      title="السابق"
                      className="takaful--primary-button-prev"
                      onClick={handlePrevTab}
                      disabled={loading}
                    />
                  )}
                </div>
              </Collapse.Panel>

              <Collapse.Panel
                disabled={isTabDisabled("4")}
                className="takaful--header-recipient-Panel takaful--header-radius"
                key="4"
                header={
                  <div className="takaful--header-recipient-container">
                    <div className="takaful--header-recipient-collapse">
                      <img width={20} src={dollar} alt="money" />
                      <span className="takaful--add-recipient-title">
                        مصادر الدخل
                      </span>
                    </div>
                  </div>
                }
              >
                <Form form={formIncomes} layout="vertical">
                  <IncomeSourceData
                    orphanCount={nbOrphan}
                    form={formIncomes}
                    incomeSources={incomeSources}
                  />
                </Form>
                <div className="takaful--add-recipient-btn-container">
                  <SecondaryButton
                    title={activeTab === "6" ? "تسجيل" : "التالي"}
                    onClick={handleNextTab}
                    disabled={loading || (activeTab === "6" && !isChecked)}
                    loading={loading}
                  />
                  {activeTab !== "1" && (
                    <PrimaryButton
                      title="السابق"
                      className="takaful--primary-button-prev"
                      onClick={handlePrevTab}
                      disabled={loading}
                    />
                  )}
                </div>
              </Collapse.Panel>

              <Collapse.Panel
                disabled={isTabDisabled("5")}
                className="takaful--header-recipient-Panel takaful--header-radius"
                key="5"
                header={
                  <div className="takaful--header-recipient-container">
                    <div className="takaful--header-recipient-collapse">
                      <img width={20} src={tab} alt="folder" />
                      <span className="takaful--add-recipient-title">
                        الإلتزامات الجّارية
                      </span>
                    </div>
                  </div>
                }
              >
                <Form form={formLiability} layout="vertical">
                  <LiabilityData form={formLiability} />
                </Form>
                <div className="takaful--add-recipient-btn-container">
                  <SecondaryButton
                    title={activeTab === "6" ? "تسجيل" : "التالي"}
                    onClick={handleNextTab}
                    disabled={loading || (activeTab === "6" && !isChecked)}
                    loading={loading}
                  />
                  {activeTab !== "1" && (
                    <PrimaryButton
                      title="السابق"
                      className="takaful--primary-button-prev"
                      onClick={handlePrevTab}
                      disabled={loading}
                    />
                  )}
                </div>
              </Collapse.Panel>
              <Collapse.Panel
                className="takaful--header-recipient-Panel takaful--header-radius"
                key="6"
                disabled={isTabDisabled("6")}
                header={
                  <div className="takaful--header-recipient-container">
                    <div className="takaful--header-recipient-collapse">
                      <img width={20} src={folder} alt="folder" />
                      <span className="takaful--add-recipient-title">
                        الأوراق الثبوتية
                      </span>
                    </div>
                  </div>
                }
              >
                <Form form={formDocs} layout="vertical">
                  <IdentityPapersData form={formDocs} />
                  <Row
                    gutter={16}
                    style={{ paddingTop: "-5rem", paddingRight: "2rem" }}
                  >
                    <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                      <Form.Item
                        name="declaration_accuracy"
                        valuePropName="declaration_accuracy"
                      >
                        <Checkbox onChange={handleCheckboxChange}>
                          <span className="takaful--check-style">
                            الإقرار بأن جميع البينات صحيحة
                          </span>
                        </Checkbox>
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
                <div className="takaful--add-recipient-btn-container">
                  <SecondaryButton
                    title={activeTab === "6" ? "تسجيل" : "التالي"}
                    onClick={handleNextTab}
                    disabled={loading || (activeTab === "6" && !isChecked)}
                    loading={loading}
                  />
                  {activeTab !== "1" && (
                    <PrimaryButton
                      title="السابق"
                      className="takaful--primary-button-prev"
                      onClick={handlePrevTab}
                      disabled={loading}
                    />
                  )}
                </div>
              </Collapse.Panel>
            </Collapse>
          </div>
        ) : (
          <>
            <Tabs
              style={{ marginTop: "-50px" }}
              activeKey={activeTab}
              onChange={setActiveTab}
              direction="rtl"
            >
              <TabPane
                tab={renderTabTitle(
                  "1",
                  <img width={15} src={user} alt="users" />,
                  <img width={15} src={userWhite} alt="users" />,
                  "بيانات الأب و الأم"
                )}
                key="1"
                disabled={isTabDisabled("1")}
              >
                <Form
                  form={formBeneficiary}
                  layout="vertical"
                  onValuesChange={onValuesChange}
                >
                  <ApplicantData
                    nationality={nationality}
                    academicLevels={academicLevels}
                    deathReasons={deathReasons}
                    maritalStatus={maritalStatus}
                    healthStates={healthStates}
                    identificationTypes={identificationTypes}
                    form={formBeneficiary}
                  />
                </Form>
              </TabPane>

              <TabPane
                tab={renderTabTitle(
                  "2",
                  <img width={20} src={users} alt="users" />,
                  <img width={20} src={usersWhite} alt="users" />,
                  "بيانات أفراد الأسرة"
                )}
                key="2"
                disabled={isTabDisabled("2")}
              >
                <Form form={formOrphans} layout="vertical">
                  <FamilyData
                    parentForm={formBeneficiary}
                    form={formOrphans}
                    nationality={nationality}
                    identificationTypes={identificationTypes}
                    maritalStatus={maritalStatus}
                  />
                </Form>
              </TabPane>

              <TabPane
                tab={renderTabTitle(
                  "3",
                  <img width={15} src={location} alt="localtion" />,
                  <img width={20} src={locationWhite} alt="localtion" />,
                  "بيانات السكن"
                )}
                key="3"
                disabled={isTabDisabled("3")}
              >
                <Form form={formHousing} layout="vertical">
                  <HousingData
                    form={formHousing}
                    housingTypes={housingTypes}
                    housingStates={housingStates}
                    housingOwnerships={housingOwnerships}
                  />
                  <AddressData governorates={governorates} form={formHousing} />
                </Form>
              </TabPane>

              <TabPane
                tab={renderTabTitle(
                  "4",
                  <img width={20} src={dollar} alt="money" />,
                  <img width={20} src={dollarWhite} alt="money" />,
                  "مصادر الدخل"
                )}
                key="4"
                disabled={isTabDisabled("4")}
              >
                <Form form={formIncomes} layout="vertical">
                  <IncomeSourceData
                    orphanCount={nbOrphan}
                    form={formIncomes}
                    incomeSources={incomeSources}
                  />
                </Form>
              </TabPane>
              <TabPane
                tab={renderTabTitle(
                  "5",
                  <img width={20} src={tab} alt="folder" />,
                  <img width={20} src={tab} alt="folder" />,
                  "الإلتزامات الجّارية"
                )}
                key="5"
                disabled={isTabDisabled("5")}
              >
                <Form form={formLiability} layout="vertical">
                  <LiabilityData form={formLiability} />
                </Form>
              </TabPane>
              <TabPane
                tab={renderTabTitle(
                  "6",
                  <img width={20} src={folder} alt="folder" />,
                  <img width={20} src={folder} alt="folder" />,
                  "الأوراق الثبوتية"
                )}
                key="6"
                disabled={isTabDisabled("6")}
              >
                <Form form={formDocs} layout="vertical">
                  <IdentityPapersData form={formDocs} />
                  <Row
                    gutter={16}
                    style={{ paddingTop: "-5rem", paddingRight: "2rem" }}
                  >
                    <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                      <Form.Item
                        name="declaration_accuracy"
                        valuePropName="declaration_accuracy"
                      >
                        <Checkbox onChange={handleCheckboxChange}>
                          <span className="takaful--check-style">
                            الإقرار بأن جميع البينات صحيحة
                          </span>
                        </Checkbox>
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
              </TabPane>
            </Tabs>
            <div className="takaful--add-recipient-btn-container">
              <SecondaryButton
                title={activeTab === "6" ? "تسجيل" : "التالي"}
                onClick={handleNextTab}
                disabled={loading || (activeTab === "6" && !isChecked)}
                loading={loading}
              />
              {activeTab !== "1" && (
                <PrimaryButton
                  title="السابق"
                  className="takaful--primary-button-prev"
                  onClick={handlePrevTab}
                  disabled={loading}
                />
              )}
            </div>
          </>
        )}
        <OtpModal
          open={isModalVisible}
          onClose={handleCloseOtpModal}
          recordId={beneficiryId}
          model={"beneficiary"}
          mobile={formBeneficiary.getFieldValue("mobile")}
        />
      </div>
    </>
  );
};

export default AddRecipient;
